import React from "react";
import { useDispatch } from "react-redux";
import MultiButton from "../../../Docuclipper/MultiButton";
import {
  TemplateFieldV2,
  FieldType,
} from "../../../../docuclipper/DocuclipperTypes";

import {
  updateTemplateField,
  fetchExtractedData,
} from "../../../../redux/reducers/TemplateField";
import { withSelectedField } from "./withSelectedField";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useMedia } from "react-media";
import { GLOBAL_MEDIA_QUERIES } from "../../../../utils/media";

type Props = {
  selected: FieldType;
  onSelected: (fieldType: FieldType) => any;
  small: boolean;
};
export const _FieldTypeSelector: React.SFC<Props> = ({
  selected,
  onSelected,
  small,
}) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let spanClass = "20";
  if (matches.small) {
    spanClass = "w20";
  } else if (matches.medium) {
    spanClass = "w20";
  } else if (matches.large) {
    spanClass = "w35";
  }
  return (
    <>
      <MultiButton
        btnClassName=""
        spanClassName={spanClass}
        selected={selected}
        onSelect={(option) => {
          const value = option.apiName;
          let fieldType: TemplateFieldV2["fieldType"] = value.toLowerCase() as TemplateFieldV2["fieldType"];
          onSelected(fieldType);
        }}
        options={[
          {
            text: small ? "" : "Text",
            apiName: "text",
            icon: "font" as IconProp,
            tooltip: () => <span>Text</span>,
          },
          {
            text: small ? "" : "Number",
            apiName: "number",
            icon: "hashtag" as IconProp,
            tooltip: () => <span>Number</span>,
          },
          {
            text: small ? "" : "Currency",
            apiName: "currency",
            icon: "dollar-sign" as IconProp,
            tooltip: () => <span>Currency</span>,
          },
          {
            text: small ? "" : "Date",
            apiName: "date",
            icon: "calendar" as IconProp,
            tooltip: () => <span>Date</span>,
          },
        ]}
      />
    </>
  );
};

export const _FieldTypeSelectorText: React.FC<{
  field: TemplateFieldV2;
}> = ({ field }) => {
  const dispatch = useDispatch();
  if (!["ocr", "handwriting"].includes(field.toolType)) {
    return null;
  }
  return (
    <_FieldTypeSelector
      small={false}
      selected={field.fieldType}
      onSelected={(fieldType: FieldType) => {
        dispatch(
          updateTemplateField({
            id: field.id,
            update: {
              fieldType,
            },
          })
        );
        dispatch(fetchExtractedData({ id: field.id }));
      }}
    />
  );
};

export const FieldTypeSelectorText = withSelectedField(_FieldTypeSelectorText);
